import axios from "../../axios";

export const getBouncedCheques = async (accountId, aggregated = false) => {
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/bouncedCheque?reportReferenceId=${accountId}` : `/api/v3/analysis/bouncedCheque?accountId=${accountId}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
};